var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E72631"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.55a2.682 2.682 0 0 0-2.569 3.453L7.603 9.91l.01.033c.043.142.083.276.149.393a1.2 1.2 0 0 0 .784.584c.131.03.271.029.42.029h.069c.148 0 .288 0 .419-.03a1.2 1.2 0 0 0 .784-.583 1.93 1.93 0 0 0 .149-.393l.01-.033 1.172-3.908A2.682 2.682 0 0 0 9 2.55ZM9 12.3a1.95 1.95 0 1 0 0 3.9 1.95 1.95 0 0 0 0-3.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.90ae3f4f7f0ffaad82b3398f64c730ad.svg";
export { ForwardRef as ReactComponent };